
<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/forgot-password.png" width="80%" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Recuperar contraseña</h4>
                                    <p>Por favor ingresa tu correo electrónico para que recibas las instrucciones de cambiar contraseña.</p>
                                </div>
                                    <vs-input
                                        v-validate="'required|email|min:3'"
                                        data-vv-validate-on="blur"
                                        name="email"
                                        icon-no-border
                                        icon="icon icon-user"
                                        icon-pack="feather"
                                        label-placeholder="Email"
                                        v-model="email"
                                        class="w-full mb-8"/>
                                <vs-button type="border" to="/pages/login" class="px-4 w-full md:w-auto">Regresar a login</vs-button>
                                <vs-button class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0" :disabled="!validateForm" @click="RecuperarContra">Recuperar contraseña</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>
export default {
  data () {
    return {
        email:""
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== '' 
    }
  },
  methods: {
    openLoading(){
      this.$vs.loading({type:'corners'});
    },
    closeLoading(){
      this.$vs.loading.close();
    },
    RecuperarContra(){
        const POST = {
            email: this.email,
        };
        this.openLoading();
        this.$http.post('App','RecuperarPass',POST,(data)=>{
            if(data=='notexist'){
              this.$vs.notify({
                time: 2500,
                title: 'Error',
                text: "Este correo electrónico no está registrado!",
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
              this.email = "";
              this.closeLoading();
            }if(data==true){
              this.$vs.notify({
                time: 2500,
                title: 'succes',
                text: "Su contraseña fue enviada a su correo electrónico!",
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
              })
              this.$router.push('/pages/login').catch(() => {});
              this.closeLoading();
            }
        });
    },
  }
}
</script>